module.exports = __webpack_public_path__ + "static/index/img/baikal-1003.0f1c925f.jpg";